<template>
  <v-icon v-bind="$attrs">
    {{ icon }}
  </v-icon>
</template>
<script>
import presentationService from '../../../../../ml/services/presentationService';
export default {
  props: {
    presentation: {
      type: Object,
      required: true,
    },
  },
  computed: {
    icon() {
      return presentationService.getIcon((this.presentation.presentation_type));
    }
  }
}
</script>
